import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';
import { Observable } from 'rxjs';

import { InsightsOnboardingResponse } from '../insights/insights-schedule.model';
import { DepartmentTargetBulkPayload, DepartmentTargetModel } from './department-target.model';

@Injectable({
  providedIn: 'root',
})
export class DepartmentTargetAPI {
  private gateway = inject(ApiGateway);

  private endpoint = 'departments';

  load(departmentId: string): Observable<DepartmentTargetModel[]> {
    return this.gateway.get(`${this.endpoint}/${departmentId}/target`);
  }

  loadTargets(start_date: string, end_date: string): Observable<DepartmentTargetModel[]> {
    return this.gateway.get(`${this.endpoint}/target`, { params: { start_date, end_date } });
  }

  edit(departmentTarget: DepartmentTargetModel[]): Observable<DepartmentTargetModel[]> {
    return this.gateway.put(`${this.endpoint}/target`, departmentTarget);
  }

  bulkEdit(departmentId: string, departmentTarget: DepartmentTargetBulkPayload[]): Observable<DepartmentTargetModel[]> {
    return this.gateway.put(`${this.endpoint}/${departmentId}/target`, departmentTarget);
  }

  setOnboardingTargets(departmentTarget: Partial<DepartmentTargetModel>): Observable<InsightsOnboardingResponse> {
    return this.gateway.post(`onboarding/insights`, departmentTarget);
  }
}
